// extracted by mini-css-extract-plugin
module.exports = {"noBorderRadius":"BenefitsDetails_noBorderRadius__XNe4J","Trigger":"BenefitsDetails_Trigger__CJFwE"};